export default "__VITE_ASSET__D3b42e6K__"